var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',[_c('card-title-row',{staticClass:"py-6",attrs:{"translationPath":"sidebar.importDxf.title","align-class":"align-center"}}),_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',[_c('dxf-layers-list-wrapper')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }